import * as effects from 'redux-saga/effects';

import {
  DEFAULT_PREFIX,
  WEBSOCKET_CLOSED,
  WEBSOCKET_OPEN,
} from '@giantmachines/redux-websocket';
import { sendMessageRequest } from './workers/sendMessageRequest';
import { openedSockets } from './workers/openedSockets';
import { reopenSockets } from './workers/reopenSockets';
import { handleResponse } from './workers/handleResponse';

import { wsActions } from '../actions';
// IMPORTS

function* watchSendMessageRequest() {
  yield effects.takeEvery(
    wsActions.sendMessageRequest.type,
    sendMessageRequest,
  );
}

function* watchHandleResponse() {
  yield effects.takeEvery(wsActions.handleResponse.type, handleResponse);
}
function* watchReopenSockets() {
  yield effects.takeEvery(
    `${DEFAULT_PREFIX}::${WEBSOCKET_CLOSED}`,
    reopenSockets,
  );
}
function* watchOpenedSockets() {
  yield effects.takeEvery(
    `${DEFAULT_PREFIX}::${WEBSOCKET_OPEN}`,
    openedSockets,
  );
}
// WATCHERS
export function* watchWs() {
  // eslint-disable-next-line prettier/prettier
  yield effects.all([
    effects.call(watchSendMessageRequest),
    effects.call(watchHandleResponse),
    effects.call(watchReopenSockets),
    effects.call(watchOpenedSockets),
    // INJECT
  ]);
}
